import React, { useState, useEffect, useRef, Suspense } from 'react';
import { loadModule } from '../../utils';
import { ROSTER_GROUPS_HATCH } from '../../../auth/auth';

const RosterGroupsHatch = React.lazy( () => loadModule(
    `${ ROSTER_GROUPS_HATCH }/remoteEntry.js`,
    'roster_groups_hatch',
    './RosterGroupsHatch'
) );

const RosterGroups = ( { auth, name, form, personId, companyId, handleSelectCallback, rosterEditButton, disabled, segmentIds } ) => {
    const [ mountKey, setMountKey ] = useState( 0 );
    // Tracks what the Select currently holds, sourced from its own onChange (order-insensitive)
    const internalIdsRef = useRef( segmentIds ?? [] );

    const sameIds = ( a, b ) => {
        if ( a.length !== b.length ) {return false;}
        const setB = new Set( b );
        return a.every( v => setB.has( v ) );
    };

    const handleSelect = ( groupIds ) => {
        internalIdsRef.current = groupIds; // the Select already shows this — don't remount for it
        handleSelectCallback( groupIds );
    };

 /**
  * Warning: Hacky
  * RosterGroupHatch doesnt properly control the Select component with the form value and instead feeds selectedGroupIds into defaultValue.
  * The Select is uncontrolled, so the only way to push an external value into it is to remount (via key). But user-driven
  * selections are already reflected by the Select natively, so we remount ONLY when the incoming segmentIds did not originate
  * from the Select itself (init / reset / external delete). This avoids re-triggering GroupInput's fetch on every selection.
  */
    useEffect( () => {
        const next = segmentIds ?? [];
        if ( !sameIds( next, internalIdsRef.current ) ) {
            internalIdsRef.current = next;
            setMountKey( k => k + 1 );
        }
    }, [ segmentIds ] );

    return (
        <Suspense fallback={ <div></div> }>
            <RosterGroupsHatch
                key={ mountKey }
                disabled={ disabled }
                className="roster-group-div"
                label="Group(s)"
                auth={ auth._auth.state }
                selectedGroupIds={ segmentIds }
                fetch= { () => {} }
                handleSelect={ handleSelect }
                disableButton={ false } 
                personId={ personId }
                companyId={ companyId }
                hideAddEditGroups={ !rosterEditButton }
            />
        </Suspense>
    );
};

export default RosterGroups;
